<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('乐谱标题')" prop="title">
                <a-input v-model="queryParam.title" @pressEnter="handleQuery" :maxLength="32" :placeholder="$t('请输入')+$t('乐谱标题')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('难度')" prop="difficulty">
                <a-select v-model="queryParam.difficulty" :placeholder="$t('请选择')+$t('难度')" allow-clear>
                  <a-select-option :value="10">{{ $t('入门') }}</a-select-option>
                  <a-select-option :value="20">{{ $t('初级') }}</a-select-option>
                  <a-select-option :value="30">{{ $t('中级') }}</a-select-option>
                  <a-select-option :value="40">{{ $t('高级') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('上传来源')" prop="uploaderType">
                <a-select v-model="queryParam.uploaderType" :placeholder="$t('请选择')+$t('上传来源')" allow-clear>
                  <a-select-option :value="10">{{ $t('平台') }}</a-select-option>
                  <a-select-option :value="20">{{ $t('用户') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('审核状态')" prop="auditStatus">
                <a-select v-model="queryParam.auditStatus" :placeholder="$t('请选择')+$t('审核状态')" allow-clear>
                  <a-select-option :value="1300">{{ $t('待审核') }}</a-select-option>
                  <a-select-option :value="1310">{{ $t('已通过') }}</a-select-option>
                  <a-select-option :value="1320">{{ $t('已驳回') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageVisible = false">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['sheet:library:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['sheet:library:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['sheet:library:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form ref="createForm" @ok="getList" />
      <audit-form ref="auditForm" @ok="getList" />
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 1300 }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template slot="coverPic" slot-scope="text, record">
          <div>
            <img v-if="record.coverPic" :src="record.coverPic" style="width:50px;height:50px;" @click="handleRecordPreview(record.coverPic)" alt="coverPic"/>
          </div>
        </template>
        <span slot="uploaderType" slot-scope="text, record">
          <a-tag :color="record.uploaderType === 20 ? 'blue' : 'green'">{{ record.uploaderTypeName }}</a-tag>
        </span>
        <span slot="auditStatus" slot-scope="text, record">
          <a-tag :color="auditColor(record.auditStatus)">{{ record.auditStatusName }}</a-tag>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.auditForm.open(record)" v-hasPermi="['sheet:library:audit']">
             <a-icon type="audit" />{{$t('审核')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['sheet:library:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['sheet:library:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['sheet:library:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['sheet:library:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSheet, delSheet } from '@/api/sheet/sheet'
import { mapGetters } from 'vuex'
import CreateForm from './modules/CreateForm'
import AuditForm from './modules/AuditForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'SheetLibrary',
  components: {
    CreateForm,
    AuditForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      previewImageVisible: false,
      previewUrl: '',
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        title: null,
        difficulty: undefined,
        uploaderType: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('封面'),
          dataIndex: 'coverPic',
          scopedSlots: { customRender: 'coverPic' },
          align: 'center'
        },
        {
          title: this.$t('乐谱标题'),
          dataIndex: 'title',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('分类'),
          dataIndex: 'categoryName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('难度'),
          dataIndex: 'difficultyName',
          align: 'center'
        },
        {
          title: this.$t('文件类型'),
          dataIndex: 'fileTypeName',
          align: 'center'
        },
        {
          title: this.$t('上传来源'),
          dataIndex: 'uploaderType',
          scopedSlots: { customRender: 'uploaderType' },
          align: 'center'
        },
        {
          title: this.$t('上传用户'),
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核状态'),
          dataIndex: 'auditStatus',
          scopedSlots: { customRender: 'auditStatus' },
          align: 'center'
        },
        {
          title: this.$t('浏览量'),
          dataIndex: 'viewCount',
          align: 'center'
        },
        {
          title: this.$t('下载量'),
          dataIndex: 'downloadCount',
          align: 'center'
        },
        {
          title: this.$t('收藏量'),
          dataIndex: 'favoriteCount',
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    auditColor(status) {
      if (status === 1310) return 'green'
      if (status === 1320) return 'red'
      return 'orange'
    },
    /** 查询乐谱列表 */
    getList () {
      this.loading = true
      pageSheet(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        title: undefined,
        difficulty: undefined,
        uploaderType: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delSheet({ idList: that.ids })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('删除成功'), 3)
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    }
  }
}
</script>
